const store = new Map();

export const BLOG_LIST_TTL    = 60_000;   // 1 min
export const BLOG_META_TTL    = 120_000;  // 2 min
export const BLOG_DETAIL_TTL  = 300_000;  // 5 min
export const MY_BLOGS_TTL     = 30_000;   // 30 sec

export const queryCache = {
  get(key) {
    const entry = store.get(key);
    if (!entry) return null;
    if (Date.now() > entry.expiresAt) { store.delete(key); return null; }
    return entry.data;
  },
  set(key, data, ttlMs) {
    store.set(key, { data, expiresAt: Date.now() + ttlMs });
  },
  invalidate(key) {
    store.delete(key);
  },
  invalidatePrefix(prefix) {
    for (const key of store.keys()) {
      if (key.startsWith(prefix)) store.delete(key);
    }
  }
};
